import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=4e5990d2&scoped=true"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js"
import style0 from "./NavbarToggleButton.vue?vue&type=style&index=0&id=4e5990d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5990d2",
  null
  
)

export default component.exports